import axios from 'axios';

export function getFieldName(attribute: string): string {
  switch (attribute) {
    case 'allowDocumentDownload':
      return 'entity-document-download';
    case 'allowSigningForward':
      return 'entity-is-signing-forward';
    case 'requireSelfSign':
      return 'entity-is-selfsign';
    case 'verifySmsOpen':
      return 'entity-verify_sms_open';
    case 'verifySmsSign':
      return 'entity-verify_sms_sign';
    case 'isSigningBiometric':
      return 'entity-is-signing-biometric';
    case 'isSigningInitials':
      return 'entity-is-signing-initials';
    case 'isSigningEId':
      return 'entity-is-signing-eid';
    case 'isSigningWrite':
      return 'entity-is-signing-write';
    case 'hasDisabledComments':
      return 'entity-is-disable-comment';
    case 'doIdentifyRecipient':
      return 'entity-is-identify-recipient';
    case 'documentUniqueId':
      return 'entity-document-unique-id';
    case 'hasEsignConsent':
      return 'entity-is-esign-consent';
    default:
      return '';
  }
}

export async function postSetting(payload: FormData): Promise<number> {
  const {
    data: { status },
  } = await axios.post('/save/settings', payload);
  return +status;
}

export function getFieldValue(value: boolean | number | string): string {
  if (typeof value === 'boolean') {
    return value ? '1' : '0';
  }
  return value.toString();
}
